import { useEffect, useState } from "react";
import Icon from "../../lib/icons";
import { useLang } from "../../i18n";
import { api, resolveMedia } from "../../lib/api";
import { ACTIVITIES } from "../../data/content";
import { Reveal, SectionHeading } from "../Reveal";

export default function Activities({ limit }) {
  const { pick, lang } = useLang();
  const [dynamic, setDynamic] = useState(null);

  useEffect(() => {
    api.get("/activities").then((r) => setDynamic(r.data.items || [])).catch(() => setDynamic([]));
  }, []);

  const useDynamic = dynamic && dynamic.length > 0;
  const items = useDynamic
    ? (limit ? dynamic.slice(0, limit) : dynamic)
    : (limit ? ACTIVITIES.slice(0, limit) : ACTIVITIES);
  return (
    <section data-testid="activities-section" className="py-24 bg-ngo-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          overline={pick({ hi: "गतिविधियां", en: "Activities" })}
          title={pick({ hi: "हमारी प्रमुख गतिविधियां", en: "Our Key Activities" })}
          description={pick({
            hi: "जमीनी स्तर पर समुदाय के साथ मिलकर चलाए जा रहे वास्तविक कार्यक्रम।",
            en: "Real programs being run with communities at the grassroots level.",
          })}
          testid="activities-heading"
        />
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((act, i) => {
            const title = useDynamic ? (lang === "hi" ? act.title_hi : act.title_en || act.title_hi) : pick({ hi: act.hi.title, en: act.en.title });
            const desc = useDynamic ? (lang === "hi" ? act.desc_hi : act.desc_en || act.desc_hi) : pick({ hi: act.hi.desc, en: act.en.desc });
            const img = useDynamic ? act.image : act.img;
            return (
            <Reveal key={useDynamic ? act.id : act.hi.title} i={i % 4}>
              <article
                data-testid={`activity-card-${i}`}
                className="group h-full bg-white rounded-2xl border border-ngo-deep/10 overflow-hidden hover:-translate-y-1.5 hover:shadow-[0_18px_44px_rgba(23,107,58,0.16)] transition-[box-shadow,transform] duration-300"
              >
                <div className="relative h-44 overflow-hidden bg-ngo-mint">
                  {img ? (
                    <img
                      src={resolveMedia(img)}
                      alt={title}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center text-ngo-deep/30"><Icon name={useDynamic ? "HeartHandshake" : act.icon} size={44} /></div>
                  )}
                  <div className="absolute inset-0 bg-ngo-forest/0 group-hover:bg-ngo-forest/30 transition-colors duration-500" />
                  <div className="absolute bottom-3 left-3 w-10 h-10 rounded-xl bg-ngo-cream/95 flex items-center justify-center text-ngo-deep shadow">
                    <Icon name={useDynamic ? "HeartHandshake" : act.icon} size={19} />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-heading font-bold text-lg text-ngo-ink">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ngo-ink/65">{desc}</p>
                </div>
              </article>
            </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
